<div class="flexJustify">
  <img class="input-img" src="../../../assets/buscar.png" />
  <input class="input-tabla" type="text" id="search" name="search" />
</div>
